import { useFormContext } from 'react-hook-form';

import { Checkbox } from '@grafana/ui';
import { t } from 'app/core/internationalization';

export function WorkdaysOnlyCheckbox() {
  const { register } = useFormContext();

  return (
    <Checkbox
      {...register('schedule.workdaysOnly')}
      label={t('share-report.schedule.workdays-only', 'Send Monday to Friday only')}
    />
  );
}
